import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ITotalServicios } from '../models/totalservicios';
@Injectable({
  providedIn: 'root'
})
export class ReporteService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.SUrlgApi + 'Reporte';
  }
  GetTotalDeServicios(num_opcion:number, fecha: string):Observable<ITotalServicios[]>{
    const valores = {
      params: new HttpParams().
        set('fecha', fecha)
    };
    return this.http
      .get<ITotalServicios[]>(this.apiUrl + '/GetTotalDeServicios/'+num_opcion, valores)
      .pipe(retry(1), catchError(this.handleError));

  }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
